import $ from "jquery";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(document).ready(function () {
  $(".animation-reveal").each(function (index) {
    gsap.fromTo(
      this,
      {
        yPercent: 15,
        opacity: 0,
      },
      {
        opacity: 1,
        yPercent: 0,
        duration: 1,
        ease: "ease",
        scrollTrigger: {
          trigger: this,
          start: "top 60%",
          once: true,
        },
      },
    );
  });

  $(".js-hero-title").each(function () {
    gsap.to($(this), {
      opacity: 1,
    });
  });
});

const childrenFadeEffect = (target) => {
  // Fade in animation for defined element's children
  const $fadeChildren = $(target);
  if ($fadeChildren.length) {
    $fadeChildren.each((_, el) => {
      const showTl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: "top 90%",
        },
      });
      showTl.fromTo(
        $(el).children(),
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, duration: 1, stagger: 0.5, ease: "ease" },
      );
    });
  }
};

childrenFadeEffect(".js-fade__children");
